import _  from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import {  faPlus, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicableTableSettings, codesRegionStateList } from '../../../../tableSettings';

import {
  TextAlignLeftRenderer,
  TextRenderer,
} from '../../../../uiControls/SmartTableRenderers';

import useFastStorage from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';

import ApplicationContext from '../../../../ApplicationContext';
import SecondaryButton from '../../../../ui/SecondaryButton';
import { Search, initialSearch, isFilterObjectEmpty } from '../../../../filtering';
import { Portal } from 'react-portal';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeStateListItem } from '../../../../fms.data/models/CodeStateListItem';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import TextBox from '../../../../ui/TextBox';
import EditableTable, { CellData, EditableTableHandle, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";

import postal from 'postal';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
// function ActionRenderer({ data, row }: any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew && data[row.index].listSec?.grantDel &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

function CodeRenderer({data, row, cell}: any) {
  // useEffect(() => {
  //   const focusElement = document.getElementById('ifms-code') as HTMLInputElement;
  //   if (focusElement) {
  //     focusElement.focus();
  //     focusElement.select();
  //   }
  // },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );
    const changeLineItem = data[0].changeLineItem;
    const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox maxLength={2} textId={`ifms-code-${row.index}`} value={l.code} onChange={(e) => {
          changeLineItem(row.index, {code: e.target.value, isUpdate: true})
          }} />
      </div>
    );
}

function StateRenderer({data, row, cell}: any) {
    const changeLineItem = data[0].changeLineItem;
    const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox maxLength={30} textId={`ifms-state-${row.index}`} value={l.stateName} onChange={(e) => {
          changeLineItem(row.index, {stateName: e.target.value, isUpdate: true})
          }} />
      </div>
    );
}

function CountryRenderer({data, row, cell}: any) {
    const changeLineItem = data[0].changeLineItem;
    const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox maxLength={2} textId={`ifms-country-${row.index}`} value={l.country} onChange={(e) => {
           changeLineItem(row.index, {country: e.target.value, isUpdate: true})
          }}
          // onTabNext={() => {
          //   const focusElement = document.getElementById('ifms-code') as HTMLInputElement;
          //   if (focusElement) {
          //     focusElement.focus();
          //     focusElement.select();
          //     return true;
          //   }
          //   return false;
          // }}
        />
      </div>
    );
}

class EditableCodeStateInfoListItem extends CodeStateListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
}

function formatElement(data: any) {
  const result = new EditableCodeStateInfoListItem();
  result.code = data.code;
  result.stateName = data.stateName;
  result.country = data.country;
  result.cid2 = data.cid2;
  result.cid = data.cid;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function StateComponent({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
//  const { selectTableRow, clearTableSelection, tableNavigationCleanup } = useTableNavigation('codes-region-state-list', onRowIndexChanged, onRowSelect, [], false, true, true);

  const tableRef = useRef<EditableTableHandle>(null);
  const masterTableRef = useRef<EditableTableHandle>(null);
  const savedDataRef = useRef<Array<CodeStateListItem>>([]);
  const oriData = useRef<CodeStateListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-region-state-list`, []);
  //const [ei, setEi, , ediRef] = useFastStorage(`ifms-referenceFiles-region-state-editindex`, -1);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-region-state-orderby`, {
    orderBy: 'code',
    orderByAscending: true,
    //general1: 'Code',
    //generalText1: '',   //<pt220819>
    //pageSize: systemSettings.defaultPageSize,
  });
 //const addingToTheFirstLine = useRef(false);

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeState);

  const tableHeight = 520;
  const listItemType = 'CodeStateListItem';

  const [focusFirstCell, setFocusFirstCell] = useState(true);
  const { FilterButton, search } = useFilterBar(
    codesRegionStateList,
    undefined,
    getDefaultOrderBy, 
    String(componentIndex)
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'code',
      orderByAscending: true,
    };
  }

  function setData(d: any, callByFetchData: boolean = false) {
    setFocusFirstCell(callByFetchData);
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeStateListItem, oriData.current, d));
  }

  async function fetchData(api:any, search:Search) {
    setLoading(true);

    const apiResult = await api.getListItems(JobNames.State,
      listItemType,
      CodeStateListItem.calculateSearchParameters(search),
      1, search.pageSize);

    setData(formatData(apiResult && apiResult.entities ? apiResult.entities : []), true);
    setOrderBy(getDefaultOrderBy());
    
    setFocusFirstCell(false);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);

    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
  }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll:boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await fetchData(appContext.api, searchValue);
  }

  // async function requestOperationCancel() {
  //   const doCancel = await showGlobalYesNoDialog(<p>Are you sure you want to cancel Edit operation</p>);
  //   if (doCancel) {
  //     cancelOperation(false)
  //   } else {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80);
  //   }
  // }

  // async function onRowIndexChanged(rowIndex: number) {
  //   if (rowIndex < 0 && ediRef.current >= 0) {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80)
  //     return;
  //   }

  //   if (ediRef.current >= 0 && ediRef.current !== rowIndex) {
  //     await requestOperationCancel();
  //   }
  // }

  // function onRowSelect(rowIndex: number) {
  //   if (rowIndex >= 0 && rowIndex < dataRef.current.length && _.isEmpty(inlineElement) && (listSec?.grantEdit || listSec?.grantDel)) {
  //     setHasChanges(true);
  //     inlineElement = {...dataRef.current[rowIndex], isNew: false};
  //     setEi(rowIndex);
  //   }
  // }

  // function selectForNew() {
  //   inlineElement = {
  //     code: '', stateName: '', country: '', isNew: true,
  //   };
  //   data.unshift(inlineElement);
  //   setData(data);
  //   setEi(0);
  //   setHasChanges(true);
  // }

  // function addingLineToFirstLine(){
  //   addingToTheFirstLine.current = true;
  //   masterTableRef.current?.add();
  // }

  function addLineItem() {
    const newRow = new EditableCodeStateInfoListItem();
    newRow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newRow
    };
  }

   function applyToLineItem(rowIndex: number, change: Partial<EditableCodeStateInfoListItem>|null) {
    if (!change || !data) {
       return;
     }
     const newData = [...data];
     const checkData = data[rowIndex];
     if (!change.isNew && (change.code !== checkData.code || change.stateName !== checkData.stateName || change.country !== checkData.country)) {
       _.merge(newData[rowIndex], { ...change, hasBeenChanged: true });
       setData(newData);
       //setHasChanges(true);
     }
   }

   async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  function getIndexOfFirstInvalidCell(rowIndex: number){
    if(!data[rowIndex].code){
      return 1;
    }
    if(!data[rowIndex].stateName){
      return 2;
    }
    if(!data[rowIndex].country){
      return 3;
    }
    return undefined;
  }

  async function duplicateCell(checkData: any) {
    let duplicateFieldText = '';

    let isDuplicate = false;
    let insList = checkData.filter((x: any) => x.isNew === true);
    let chgList = checkData.filter((x: any) => x.hasBeenChanged === true && !x.isNew);
    let focusRow = -1;

    if (insList.length > 0 && data.length > 0) {
      for (let i = 0; i < insList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (insList[i].code.toUpperCase() === data[j].code.toUpperCase() && insList[i].country.toUpperCase() === data[j].country.toUpperCase()) {
            if (count === 0) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${insList[i].code}, ${insList[i].country}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (chgList.length > 0 && data.length > 0) {
      for (let i = 0; i < chgList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (chgList[i].code.toUpperCase() === data[j].code.toUpperCase() && chgList[i].country.toUpperCase() === data[j].country.toUpperCase()) {
            if (data[j].hasBeenChanged === true && !data[j].isNew && tempRow === -1) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${chgList[i].code}, ${chgList[i].country}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (!isDuplicate) {
      const apiResult = await appContext.api.checkDuplicatedKeys(JobNames.State, listItemType, insList, chgList);
      if (apiResult && apiResult.success && apiResult.message) {
        duplicateFieldText = `${apiResult.message}`;
        isDuplicate = true;
      } else if (!apiResult || !apiResult.success) {
        await showGlobalOkDialog('Could not check duplication.\r\nPlease try later.');
        return true;
      }
    }
    else
      await showGlobalOkDialog(`${duplicateFieldText}Please try after correcting duplication.`);

    return isDuplicate;
  }

  function deleteEntity(index: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[index];
    if (!element.isNew) {
      let deleteRow = savedDataRef.current.find(x => x.code === element.code && x.country === element.country)
      if (deleteRow) {
        deleteRow.isDelete = true;
        //setHasChanges(true);
      }
    }
    data.splice(index, 1);
    setData(data);
    return true;
  }

  async function save() {
    // if (!inlineElement.isNew && !hasChanges) {
    //   cancelOperation();
    //   return;
    // }

    // //<pt220819: portal
    // // const apiResult = inlineElement.isNew
    // //   ? await appContext.api.createCodesState(_.omit(inlineElement, ['isNew']))
    // //   : await appContext.api.editCodesState({..._.omit(inlineElement, ['isNew']), oldCode: data[ei].code});
    
    // // if (!apiResult || !apiResult.success) {
    // //   return;
    // // }

    // // data[ei] = formatElement(apiResult.data);
    // const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType,
    //   inlineElement.isNew ? SQLType.Insert : SQLType.Update,
    //   _.omit(inlineElement, ['isNew']));
    // if(!apiResult.success) {
    //   await showGlobalOkDialog(<p>{apiResult.message}</p>);
    //   return;
    // }

    // // code + country is pkey
    // data[ei] = formatElement(inlineElement);

    // //pt220819>
    // cancelOperation(true);
    if (!data) {
      return;
    }

    let validData = dataRef.current.filter((x:any) => x.code && x.stateName && x.country);

    let errMsg = '';
    const dataToSave = validData.filter((x:any, i:number) => x.isNew || x.hasBeenChanged === true);
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(false);
      return;
    }
    setLoading(true);
  
    for(let i = 0; i < dataToDelete.length; ++i){
      const s = dataToDelete[i];
      const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      if(!apiResult || !apiResult.success)
         errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }

   if(dataToSave.length > 0){
      const isDuplicate = await duplicateCell(dataToSave);
      if(isDuplicate){
        setLoading(false);
        return;
      }

    const apiResult:ApiResult<InsertResult> = await appContext.api.saveList(listItemType, dataToSave);
    if(!apiResult || !apiResult.success)
        errMsg += (errMsg ? '\n' : '' ) + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);

    else{
      dataToSave.forEach((x:any) => {
        const index = data.findIndex((d: any) => d.code === x.code && d.country === x.country);
        if(index >= 0){
          data[index].cid = x.code;
          data[index].cid2 = x.country;
          data[index].hasBeenChanged = false;
        }
        if(x.isNew){
          delete data[index].isNew;
        }
      })
    }
    
  }

  if(errMsg) {
    await showGlobalOkDialog(<p>{errMsg}</p>);
    setLoading(false);
    return;
  }    

  // setData(data);
  // savedDataRef.current = _.cloneDeep(data);
  // oriData.current = _.cloneDeep(data);
  
  // setLoading(false);
  // setHasChanges(false);
  reload(false);

  await showGlobalOkDialog(<p>The data has been saved</p>);
}

  function onHeaderClick(header: any) {
    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
    }

    removeData();
    sortingListData(CodeStateListItem, data, setData, orderBy);
  }

  const tableOptions: ApplicableTableSettings = {
    customTableId: 'codes-region-state-list',
    ref: tableRef,
    selectable: false,
    tableName: 'regionStateList',
    ...codesRegionStateList,
    height: `${tableHeight}px`,
    //data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, requestOperationCancel, listSec})),
    data: data.map((x: any, i: number) => ({ ...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem })),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'code', EditCell: CodeRenderer },
      { accessor: 'stateName', EditCell: StateRenderer },
      { accessor: 'country', EditCell: CountryRenderer },
      // { accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'code')
        return { type: TableCellTypes.Text, value: data[rowIndex].code };
      else if (accessor === 'stateName')
       return { type: TableCellTypes.Text, value: data[rowIndex].stateName };
      else if (accessor === 'country')
        return { type: TableCellTypes.Text, value: data[rowIndex].country, align: TableCellAligns.Center};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },
    orderBy: [orderBy],
    onHeaderClick,
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = listSec?.grantAdd;

  return (
    <div style={{marginTop:'40px'}}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Region <FontAwesomeIcon icon={faAngleRight} />&nbsp;State</h1>
        <div style={{width: '320px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})} />
        </div>
      </Portal> */}
       
      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element">
            <GreenButton size="regular" disabled={loading} onClick={save}>Save</GreenButton>
          </div>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='codes-currency-refresh-button' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={() => { reload(false); }} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>

      {/* <div style={{ width: '320px', fontWeight: 'bold' }}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}

        {/* <div className="oi-doc-title-sub-row">

           <div style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click State to Edit
          </div> 
        </div> */}
      <div style={{ display: 'flex', width: '432px' }}>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          {/* <SecondaryButton name='codes-state-add-button' size="regular" disabled={!canBeAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} /> &nbsp; Add Line</SecondaryButton> &nbsp; */}
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(false); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>  
      </div>

      <div style={{ width: '432px' }}>
      {/* <SmartTable {...tableOptions} /> */}
      <EditableTable
        initializeFocusedCell={focusFirstCell}
        ref={masterTableRef}
        tableOptions={tableOptions}
        deleteLine={deleteEntity}
        addLine={addLineItem}
        getIndexOfFirstInvalidCell={getIndexOfFirstInvalidCell}
        canDeleteRow={rowNumber => listSec?.grantDel??false}
      />
      </div>
    </div>
  );
}

export default StateComponent;
